
export enum HazmatSourceCd {
	BILL_OF_LADING = 'BillOfLading',
	DRIVER = 'Driver'}

